<div class="image-slider">
  <div class="slider-info">
  <div
    class="image-slider-blocker"
    *ngIf="
      (stateManagerProjectService.currentSelectedWindow$ | async) === 0 ||
      (stateManagerProjectService.currentSelectedWindow$ | async) === 4
    "
  ></div>
  <div class="image-slider-actions">
    <div
      class="image-slider-actions-item"
      #inputPrevious
      (click)="changeSlice(false)"
    >
      <mat-icon [svgIcon]="'previous-item'"></mat-icon>
    </div>
    <div
      class="image-slider-actions-item"
      #inputNext
      (click)="changeSlice(true)"
    >
      <mat-icon [svgIcon]="'next-item'"></mat-icon>
    </div>
  </div>
  <span class="image-slider-number"
    >Slice: {{ currentNumberOfSlice + 1 }} / {{ getTotalSlicesInfo() }}</span
  >
</div>
<div class="slider-body-container">
  <div class="slider-body">
    <div class="slices-body-info">
      <div
        class="not-viewed-slice"
        *ngFor="
          let slice of cornerstoneService.getMapOfViewedSlicesForCurrentWindow()
        "
        [ngClass]="{ 'viewed-slice': slice }"
      ></div>
    </div>
    <!-- TODO: The 'tickInterval' property no longer exists -->
    <mat-slider
      #sliceSlider
      step="1"
      min="0"
      (keydown)="$event.stopPropagation()"
      [max]="totalNumberOfSlices"
      [ngStyle]="{ width: calculateWidthOfSlices() }"
      [ngClass]="{
        disabled:
          (stateManagerProjectService.currentSelectedWindow$ | async) === 0 ||
          (stateManagerProjectService.currentSelectedWindow$ | async) === 4
      }"
      [disabled]="(stateManagerProjectService.currentSelectedWindow$ | async) === 0 ||
      (stateManagerProjectService.currentSelectedWindow$ | async) === 4"
     #ngSlider><input class="mat-slider-custom" matSliderThumb [(ngModel)]="currentNumberOfSlice" (input)="changeCurrentSlice($event)" />
    </mat-slider>
  </div>
  <span class="image-slider-percents"> {{ percentsOfViewed() }} </span>
</div>
</div>
